import { configureStore } from "@reduxjs/toolkit";
import { formatOnlinePlayerModel } from "libs/character";
import createSagaMiddleware from "redux-saga";

import { characterReducer, gameReducer, fightReducer } from "redux/reducers";
import rootSaga from "redux/sagas";
import {
  DB_WRITE_THROTTLE_THRESHOLD,
  saveCharacterData,
  debounce,
  saveOnlinePlayerData,
} from "utils/server/firebase";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    character: characterReducer,
    game: gameReducer,
    fight: fightReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

const saveState = () => {
  const gameState = store.getState().game;
  const characterState = store.getState().character;
  const fightState = store.getState().fight;

  if (gameState.isGameModeActive && characterState.userId) {
    saveCharacterData(characterState.userId, characterState.data, fightState);

    // Save instance of online player
    if (characterState.userName) {
      saveOnlinePlayerData(
        characterState.userId,
        formatOnlinePlayerModel(
          characterState.userId,
          characterState.userName,
          characterState.data
        )
      );
    }
  }
};

const debouncedSaveState = debounce(saveState, DB_WRITE_THROTTLE_THRESHOLD);

store.subscribe(debouncedSaveState);

export default store;
